export default "__VITE_ASSET__BUIcdB2V__"